import axios from 'axios';
import de from "element-ui/src/locale/lang/de";

export function getContentInfo (params) {
  return axios.postForm('/api/contentInfo_channelId.jspx', params);
}

export function contentTagByCount (params) {
  return axios.postForm('/api/contentTagByCount.jspx', params);
}
export function getContentTxtByContentId (params) {
  return axios.postForm('/api/contentTxtByContentId.jspx', params);
}
export function getContentViewById(params) {
  return axios.postForm('/api/contentViewById.jspx', params);
}
export function contentExtByContentId(params) {
  return axios.post('/api/contentExtByContentId.jspx', params)
}
export function getContentInfoNoPage(params) {
  return axios.post('/api/contentInfoNoPage.jspx', params)
}
export function contentInfoById(params) {
  return axios.post('/api/contentInfoById.jspx', params)
}



// WEBPACK FOOTER //
// ./src/api/frontierPage.js